import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/components/Layout/Layout';
/* import Login from '@/pages/Login/Login';
import ErrorPage from '@/pages/Error/Error'; */
/* // Core
import TypographyPage from '@/pages/Typography/Typography';

// Tables
import TablesBasicPage from '@/pages/Tables/Basic';

// Maps
import GoogleMapPage from '@/pages/Maps/Google';
 */
// Main
import Dashboard from '@/pages/Dashboard/Dashboard';
import Formular from '@/pages/Formular/Formular'
import Profile from '@/pages/Profile/Profile'
import AddOrderFormular from '@/pages/Formular/AddOrderFormular'
/* // Charts
import ChartsPage from '@/pages/Charts/Charts';

// Ui
import IconsPage from '@/pages/Icons/Icons';
import NotificationsPage from '@/pages/Notifications/Notifications'; */


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/app',
      name: 'Layout',
      component: Layout,
      children: [
        {
          path: 'dashboard/:token',
          name: 'DashboardPage',
          component: Dashboard,
        },
        {
          path: 'formular/:token',
          name: 'FormularPage',
          component: Formular,
        },
        {
          path: 'profile/:cin',
          name: 'ProfilePage',
          component: Profile
        },
        {
          path: 'profile/:cin/addOrder',
          name: 'AddOrderFormularPage',
          component: AddOrderFormular
        }
      ],
    },
  ],
});
